import {
  ViewBadges,
  ViewDiary,
  ViewMessage,
  ViewMilestones,
  ViewTipsOverview,
} from '../implementations';

const mappers = {
  views_block__diary_overview_block_1: ViewDiary,
  views_block__message_block_1: ViewMessage,
  views_block__tips_block_1: ViewTipsOverview,
  views_block__milestones_block_1: ViewMilestones,
  views_block__badges_block_1: ViewBadges,
};

export default mappers;
